<a
  [href]="target()"
  [attr.target]="targetBlank() ? '_blank' : null"
  class="feed-item flex flex--middle flex--space-between pr-xxsmall-y link-hover no-underline"
>
  <div class="left">
    <span class="font-body-1 bold-type nordic-blue-900-text teaser-title">{{ content().teaserTitle }}</span>
  </div>
  <div class="right flex--inline">
    <fin-date class="inline-block" [date]="content().externallyDisplayedDate" />
    <fcom-icon
      role="presentation"
      class="nordic-blue-900-text icon-medium ms-xsmall-l"
      [name]="SvgLibraryIcon.ARROW_RIGHT"
    />
  </div>
</a>
